<script>
    /**
     * Alert
     */
    import ModalHeader from './ModalHeader.vue';
    import ModalFooter from './ModalFooter';
    import NormalButton from '../widgets/NormalButton.vue';

    export default {
        alias: 'alert',
        defaultOptions () {
            return {
                title: '通知'
            };
        },
        modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
            if (!('hrefText' in options)) {
                this.hrefText = this.href;
            }
        },
        data () {
            return {
                title: '',
                text: '',
                href: '',
                hrefText: '',
                hasHTML: false,
                contentClass: '',
                linkClose: false,
                okBtnDisabled: false,
                btnText: ['确定'],
                isDrag: true,
                isHideClose: false
            };
        },
        name: 'modal-alert',
        methods: {
            onDestroy () {
                if (this.okCallback) {
                    this.okCallback();
                }
                this.close();
            },
            linkClicked () {
                if (this.linkCallback) {
                    this.linkCallback();
                }
                if (this.linkClose) {
                    this.close();
                }
            }
        },
        components: {
            ModalHeader,
            NormalButton,
            ModalFooter
        },
        mounted () {

        }
    };
</script>

<template>
    <div class="modal basic">
        <modal-header :text="title"
                      :is-hide-close="isHideClose"
                      :is-drag="isDrag"></modal-header>
        <div :class='[contentClass,"modal-content"]'>
            <div class="text" v-if="hasHTML" v-html="text"></div>
            <div class="text" v-else>{{text}}</div>
            <a class="text" v-if="href" :href="href" target="_blank" @click="linkClicked">{{hrefText}}</a>
        </div>
        <modal-footer>
            <normal-button @click="onDestroy();"
                           class="modal-footer-btn__center"
                           float="right"
                           :disabled="okBtnDisabled"
                           :text="btnText[0] || '确定'"
                           theme="blue"
            ></normal-button>
        </modal-footer>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .modal {
        .modal-style;
        min-height: 186px;
        height: auto;


        .modal-content {
            width: 520px;
        }

        a {
            color: @primaryBg;
        }
    }
</style>
